/**
 * GoodCannaGuestListStatus enum values from the API
 */
export enum GoodCannaGuestListStatus {
  Closed = 1,
  Denied = 2,
  Pending = 3,
}

/**
 * GoodCanna status string constants for display
 */
export const GOODCANNA_STATUS_PENDING = 'pending';
export const GOODCANNA_STATUS_DENIED = 'denied';
export const GOODCANNA_STATUS_CLOSED = 'approved';

/**
 * Converts GoodCannaStatus enum number to lowercase string for display
 * @param status - The GoodCannaGuestListStatus enum value from the API (or number for backwards compatibility)
 * @returns Lowercase string representation or undefined if invalid
 */
export function getGoodCannaStatusString(
  status: GoodCannaGuestListStatus | number | null | undefined,
): string | undefined {
  if (typeof status !== 'number') {
    return undefined;
  }

  switch (status) {
    case GoodCannaGuestListStatus.Closed:
      return GOODCANNA_STATUS_CLOSED;
    case GoodCannaGuestListStatus.Denied:
      return GOODCANNA_STATUS_DENIED;
    case GoodCannaGuestListStatus.Pending:
      return GOODCANNA_STATUS_PENDING;
    default:
      return undefined;
  }
}
